<template>
  <div class>
    <section class="main-content-section">
      <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
        You have only view permission.
      </div>
      <!-- Company Info -->
      <!-- <tl-accordion headerName="Company Info" :active="true">
        <template v-slot:accordionBody>
          <div class="row">
            <div class="col-4">
              <div class="row">
                <div class="col-12">
                  <tl-checkbox
                    label="Cost Center"
                    name="cost_center"
                    id="cost_center"
                    @change="onCostCenterCheck($event)"
                  />
                  <tl-select
                    label
                    :options="criteriaList"
                    class="marginleft-10p"
                    :disable="!isCostCenterChecked"
                  />
                </div>
                <div class="col-12">
                  <tl-checkbox
                    label="Salary bands"
                    name="salary_bands"
                    id="salary_bands"
                    @change="onSalaryBandsCheck($event)"
                  />
                  <tl-select
                    label
                    :options="criteriaList"
                    class="marginleft-10p"
                    :disable="!isSalaryBandsChecked"
                  />
                </div>
                <div class="col-12">
                  <tl-checkbox
                    label="Employer contribution"
                    name="employer_contri"
                    id="employer_contri"
                    @change="onEmployerContriCheck($event)"
                  />
                  <div class="twoColumnGrid p-10">
                    <tl-radio
                      label="Gross column"
                      name="employer_contri"
                      value="grossColumn"
                      id="contri_gross"
                      v-model="employerContri"
                      :disabled="!isEmployerContriChecked"
                    />
                    <tl-radio
                      label="Net Pay column"
                      name="employer_contri"
                      value="netPayColumn"
                      id="contri_netPay"
                      v-model="employerContri"
                      :disabled="!isEmployerContriChecked"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <tl-checkbox
                    label="Unpaid CTC components"
                    name="unpaid_ctc"
                    id="unpaid_ctc"
                    @change="onUnpaidCTCCheck($event)"
                  />
                  <div class="twoColumnGrid p-10">
                    <tl-radio
                      label="Gross column"
                      name="unpaid_ctc"
                      value="grossColumn"
                      id="unpaid_gross"
                      v-model="unpaidCTC"
                      :disabled="!isUnpaidCTCChecked"
                    />
                    <tl-radio
                      label="Net Pay column"
                      name="unpaid_ctc"
                      value="netPayColumn"
                      id="unpaid_netPay"
                      v-model="unpaidCTC"
                      :disabled="!isUnpaidCTCChecked"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 marginleft-5p">
              <div class="row margintop-30">
                <div class="col-12 marginbot-20">
                  <tl-checkbox label="FBP Components" name="fbp_components" id="fbp_components" />
                </div>
                <div class="col-12 marginbot-20">
                  <tl-checkbox
                    label="Standard CTC components"
                    name="ctc_components"
                    id="ctc_components"
                  />
                </div>
                <div class="col-12 marginbot-20">
                  <tl-checkbox label="LOP amount difference" name="lop_amount" id="lop_amount" />
                </div>
                <div class="col-12 marginbot-20">
                  <tl-checkbox label="EPS and EDLI" name="eps_edli" id="eps_edli" />
                </div>
                <div class="col-12 marginbot-20">
                  <tl-checkbox
                    label="Group by departments"
                    name="groupbydepartments"
                    id="groupbydepartments"
                  />
                </div>
                <div class="col-12">
                  <tl-checkbox
                    label="Allow columns with zero values"
                    name="zero_values"
                    id="zero_values"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </tl-accordion> -->
      <!-- Company Info -->

      <!-- Employee Info -->
      <tl-accordion headerName="Employee Info" :active="true">
        <template v-slot:accordionHeader>
          <span>Employee</span>
          <!-- <span style="float:right;padding-right: 20px;">10000</span> -->
        </template>
        <template v-slot:accordionBody>
          <div class="row my-2" :disabled="!ifTeamleaderAnchorPermission">
            <div class="col-12">
              <span class="filter-text" @click="selectAll(true)" v-if="selectTitle=='Select All'">{{selectTitle}}</span>
              <span class="filter-text" @click="selectAll(false)" v-else>{{selectTitle}}</span>
            </div>
          </div>
          <div class="threeColumnGrid" :disabled="!ifTeamleaderAnchorPermission">
            <div v-for="(item, index) in employeeInfoList" :key="index">
              <tl-checkbox
                :label="item.label"
                :name="'employeeInfo'+index"
                :id="'employeeInfo'+index"
                :value="item.value"
                :checked="item.checked"
                :disabled ="item.disable"
                @change="onEmployeeInfoCheck($event, item.value)"
              />
              <!-- <div class="twoColumnGrid p-10" v-if="item.label == 'Employee status'">
                <tl-radio
                  label="Active"
                  name="employeeStatus"
                  value="active"
                  id="active"
                  v-model="employeeStatus"
                  :disabled="!isEmployeeStatus"
                />
                <tl-radio
                  label="Inactive"
                  name="employeeStatus"
                  value="inactive"
                  id="inactive"
                  v-model="employeeStatus"
                  :disabled="!isEmployeeStatus"
                />
              </div> -->
            </div>
          </div>
        </template>
      </tl-accordion>

      <!-- User Defined Fields -->
      <!-- <tl-accordion headerName="User Defined Fields">
        <template v-slot:accordionBody>
          <div class="singleColumnGrid">
            <tl-checkbox
              label="Employee Name"
              name="employeeName"
              id="employeeName"
              value="employeeName"
              :checked="false"
            />
            <tl-checkbox
              label="Employee Code"
              name="employeeCode"
              id="employeeCode"
              value="employeeCode"
              :checked="false"
            />
            <tl-checkbox label="Gender" name="gender" id="gender" value="gender" :checked="false" />
            <tl-checkbox
              label="Father's Name"
              name="fathersname"
              id="fathersname"
              value="father_name"
              :checked="false"
            />
          </div>
        </template>
      </tl-accordion> -->
      <bottom-action-container class="position-fixed">
        <btn-grp slot="end">
          <!-- <btn text="Cancel" type="secondary" class></btn>
          <btn text="View Report" type="primary" class @click="DownloadReport"></btn>-->
          <btn text="Download" type="primary" class @click="downloadReport" :disabled="!ifTeamleaderAnchorPermission"></btn>
        </btn-grp>
      </bottom-action-container>

      <pop-up-message
      v-if="showSuccessMsg"
      message="Selected File Download Successfully!"
      btnText="Back To Payroll Utilities"
      @back="backfrompopup()"
    />
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "DownloadTemplate",
  data() {
    return {
      is_pf_wage_enabled: false,
      isCostCenterChecked: false,
      isSalaryBandsChecked: false,
      isEmployerContriChecked: false,
      isUnpaidCTCChecked: false,
      isEmployeeStatus: false,
      employerContri: "",
      unpaidCTC: "",
      criteriaList: [
        "All",
        "Business Unit",
        "Location",
        "Cost center",
        "Department",
        "Designation",
        "Salary band",
        "Salary grade "
      ],
      employeeInfoList: [
        {
          label: "Employee Code",
          value: "code",
          checked: true,
          disable: true
        },
        {
          label: "Employee Name",
          value: "name",
          checked: true,
          disable: true
        },
        // {
        //   label: "Reporting Manager",
        //   value: "",
        //   checked: false
        // },
        {
          label: "First Name",
          value: "first_name",
          checked: false
        },
        {
          label: "Last Name",
          value: "last_name",
          checked: false
        },
        {
          label: "Address 1 (Permanent Address)",
          value: "permanent_address",
          checked: false
        },
        {
          label: "Passport No.",
          value: "passport_number",
          checked: false
        },
        {
          label: "Address 2 (Communication Address)",
          value: "communication_address",
          checked: false
        },
        {
          label: "Gender",
          value: "gender",
          checked: false
        },
        {
          label: "Passport Expiry Date",
          value: "passport_expiry_date",
          checked: false
        },
        {
          label: "City",
          value: "city_id",
          checked: false
        },
        {
          label: "Father's Name",
          value: "father_name",
          checked: false
        },
        {
          label: "PF No.",
          value: "pf_number",
          checked: false
        },
        {
          label: "State",
          value: "state_id",
          checked: false
        },
        {
          label: "Mother's Name",
          value: "mother_name",
          checked: false
        },
        {
          label: "PF Date",
          value: "pf_enrollment_date",
          checked: false
        },
        {
          label: "Country",
          value: "country_id",
          checked: false
        },
        // {
        //   label: "Spouse's Name",
        //   value: "",
        //   checked: false
        // },
        {
          label: "UAN No.",
          value: "uan_number",
          checked: false
        },
        {
          label: "Pin",
          value: "pincode",
          checked: false
        },
        {
          label: "PF Relationship",
          value: "relationship",
          checked: false
        },
        // {
        //   label: "EPF No.",
        //   value: "",
        //   checked: false
        // },
        {
          label: "Phone No.",
          value: "phoneNumber",
          checked: false
        },
        {
          label: "DOB",
          value: "dob",
          checked: false
        },
        {
          label: "Aadhar No.",
          value: "adhar_number",
          checked: false
        },
        {
          label: "Mobile No.",
          value: "mobile_number",
          checked: false
        },
        // {
        //   label: "Employee status",
        //   value: "employee_status",
        //   checked: false
        // },
        // {
        //   label: "EPS No.",
        //   value: "",
        //   checked: false
        // },
        // {
        //   label: "Blood Group",
        //   value: "",
        //   checked: false
        // },
        {
          label: "PersonalEmail",
          value: "email_id",
          checked: false
        },
        {
          label: "PAN No.",
          value: "pan_number",
          checked: false
        },
        {
          label: "Email Official",
          value: "official_email_id",
          checked: false
        },
        {
          label: "DOJ",
          value: "date_of_joining",
          checked: false
        },
        // {
        //   label: "ESS Access",
        //   value: "",
        //   checked: false
        // },
        // {
        //   label: "Emergency No.",
        //   value: "",
        //   checked: false
        // },
        // {
        //   label: "Resignation date",
        //   value: "",
        //   checked: false
        // },
        {
          label: "ESI No.",
          value: "esi_number",
          checked: false
        },
        {
          label: "Marital Status",
          value: "marital_status",
          checked: false
        },
        // {
        //   label: "Last working Date",
        //   value: "last_working_date",
        //   checked: false
        // },
        {
          label: "Cost center",
          value: "cost_center_name",
          checked: false
        },
        // {
        //   label: "Confirmation Period",
        //   value: "",
        //   checked: false
        // },
        {
          label: "Employee category",
          value: "category_id",
          checked: false
        },
        {
          label: "Emergency contact no.",
          value: "emergency_contact_number",
          checked: false
        },
        // {
        //   label: "CTC",
        //   value: "",
        //   checked: false
        // },
        {
          label: "Employee sub category",
          value: "subcategory",
          checked: false
        },
        // {
        //   label: "Admin bank",
        //   value: "",
        //   checked: false
        // },
        // {
        //   label: "FBP",
        //   value: "",
        //   checked: false
        // },
        {
          label: "Skill type",
          value: "skill",
          checked: false
        },
        {
          label: "IFSC code",
          value: "ifsc_code",
          checked: false
        },
        // {
        //   label: "Annual VP",
        //   value: "",
        //   checked: false
        // },
        {
          label: "Pay group",
          value: "paygroup_name",
          checked: false
        },
        {
          label: "Payment mode",
          value: "payment_mode",
          checked: false
        },
        // {
        //   label: "OT Hours / Days",
        //   value: "",
        //   checked: false
        // },
        {
          label: "Location",
          value: "based_location_name",
          checked: false
        },
        // {
        //   label: "Sec Reporting Mgr",
        //   value: "",
        //   checked: false
        // },
        // {
        //   label: "Leave Encashment Day",
        //   value: "",
        //   checked: false
        // },
        {
          label: "Salary Grade",
          value: "grade_name",
          checked: false
        },
        {
          label: "Enable ESS",
          value: "is_ess_enable",
          checked: false
        },
        // {
        //   label: "Notice Period Recovery Days",
        //   value: "",
        //   checked: false
        // },
        {
          label: "Salary Band",
          value: "band_name",
          checked: false
        },
        {
          label: "Is Metro",
          value: "metro",
          checked: false
        },
        {
          label: "Bank Name",
          value: "bank_name",
          checked: false
        },
        {
          label: "Reporting Manager",
          value: "reporting_manager_id",
          checked: false
        },
        {
          label: "Bank Ac No",
          value: "bank_ac_no",
          checked: false
        },
        {
          label: "Designation",
          value: "designation_name",
          checked: false
        },
        {
          label: "Level",
          value: "level_name",
          checked: false
        },
        {
          label: "Has PF",
          value: "pf_enabled",
          checked: false
        },
        // {
        //   label: "Employee PF Contribution Rule",
        //   value: "employee_pf_contribution_rule",
        //   checked: false
        // },
        // {
        //   label: "Employer PF Contribution Rule",
        //   value: "employer_pf_contribution_rule",
        //   checked: false
        // },
        {
          label: "Applicable to LWF",
          value: "lwf_applicable",
          checked: false
        },
        {
          label: "Applicable to PT",
          value: "pt_applicable",
          checked: false
        },
        {
          label: "Entitled to ESI",
          value: "entitled_esi",
          checked: false
        },
        {
          label: "Account Holder’s Name",
          value: "account_holder_name",
          checked: false
        },
        {
          label: "Department",
          value: "department_name",
          checked: false
        },
        {
          label: "Branch Name",
          value: "branch_name",
          checked: false
        },
        {
          label: "Salary Component",
          value: "salary_component",
          checked: false
        },
        {
          label: "PT State",
          value: "pt_state",
          checked: false
        },
        {
          label: "PT Deduction Frequency",
          value: "pt_deduction_frequency",
          checked: false
        },
        // {
        //   label: "Regime Type",
        //   value: "regime_type",
        //   checked: false
        // },
        // {
        //   label: "PT Deduction Frequency",
        //   value: "pt_deduction_frequency",
        //   checked: false
        // },
        // {
        //   label: "Initiation Date",
        //   value: "initiation_date",
        //   checked: false
        // }
        {
          label: "Pan Aadhar Linked",
          value: "pan_aadhar_linked",
          checked: false
        },
        {
          label: "UDF Fields",
          value: "udf",
          checked: false
        },
        {
          label: "PF Flag",
          value: "pfFlag",
          checked: false
        },
        {
          label: "Group Date Of Joining",
          value: "group_date_of_joining",
          checked: false
        },
        {
          label: "Inoperative Pan",
          value: "inoperative_pan",
          checked: false
        },
        {
          label: "PRAN Number",
          value: "pran_number",
          checked: false
        }, {
          label: "Employment Type",
          value: "employment_type",
          checked: false
        },
        {
          label: "EPS Applicable ",
          value: "eps_applicable",
          checked: false
        },
       {
          label: "International Employee",
          value: "international_employee",
          checked: false
        },
      ],
      selectTitle: 'Select All',
      columns: ["code", "name"],
      showSuccessMsg:false,
      downloadUploadMasterTemplateValue: false,
      role: ""
    };
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.downloadUploadMasterTemplateValue) {
          return true;
        } else {
          return false;
        }
      } 
      // else {
      //   return true 
      // }
    }
  },
  mounted() {
    this.getOrgLeIdList();
  },
  activated() {
    this.getOrgLeIdList();
    this.fetchPfWageData();
  },
  methods: {
    ...mapActions({
      downloadBulkData:
        "dashboard/utilities/downloadBulkData",
      fetchPf: "onboard/statutoryinfo/pfsettings/fetchAll",
   }),
    async fetchPfWageData() {
      try {
        let res = await this.fetchPf(this.le_id);
        if (res.data.status) {
          this.is_pf_wage_enabled = res.data.payload.data.enablePFWage;
          if (this.is_pf_wage_enabled) {
            this.employeeInfoList.push({
              label: "PF Wage",
              value: "pf_wage",
              checked: false
            });
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async downloadReport() {
      let payload={
       columns:this.columns,
       leid:this.le_id,
      }
      let res= await this.downloadBulkData(payload);
      this.showSuccessMsg = true;
    },

    selectAll(flag) {
      this.columns = []
      this.employeeInfoList.forEach(element => {
        if (flag) {
          this.columns.push(element.value)
          return element.checked = flag;
        } else {
          if (element.value !== "name" && element.value !== "code") {
            return element.checked = flag;
          }
        }
      });
      this.selectTitle = flag ? 'Unselect All' : 'Select All'
    },

    onEmployeeInfoCheck(event, type) {
      if (event) {
        this.columns.push(type)
      } else {
        const index = this.columns.findIndex(i => i === type)
        this.columns.splice(index, 1)
      }
    },

    backfrompopup(){
        this.showSuccessMsg = false;
        // this.$router.push({
        // path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        // });
        this.$router.go(0);
    },

    onCostCenterCheck(event) {
      if (event) {
        this.isCostCenterChecked = true;
      } else {
        this.isCostCenterChecked = false;
      }
    },
    onSalaryBandsCheck(event) {
      if (event) {
        this.isSalaryBandsChecked = true;
      } else {
        this.isSalaryBandsChecked = false;
      }
    },
    onEmployerContriCheck(event) {
      if (event) {
        this.isEmployerContriChecked = true;
        this.employerContri = "grossColumn";
      } else {
        this.isEmployerContriChecked = false;
        this.employerContri = "";
      }
    },
    onUnpaidCTCCheck(event) {
      if (event) {
        this.isUnpaidCTCChecked = true;
        this.unpaidCTC = "grossColumn";
      } else {
        this.isUnpaidCTCChecked = false;
        this.unpaidCTC = "";
      }
    },

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.downloadUploadMasterTemplateValue = data.data.user.permissions.download_upload_master_template ? true : false;
    }

  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common

@import "@/scss/dashboard/content/_section.scss"; // Content Section
.s-twoColumnGrid {
  display: grid;
  grid-template-columns: 25% 25%;
  grid-row-gap: 0px;
  grid-column-gap: 10%;
}
.btn-center {
  position: relative;
  top: 70px;
  margin: auto;
}

span.filter-text {
  font-weight: 600;
  color: #34c0be;
  font-size: 14px;
  float:right;
  //padding-right: 20px;
  cursor: pointer;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
